import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as AppState from '../../../state/app.state';
import { AppointmentStatusGridState } from './appointment-status-grid.reducer';
import { getLoggedInUserInfo } from 'src/app/state';

export interface State extends AppState.State {
    appointmentStatusGridState: AppointmentStatusGridState;
}

const getappointmentStatusGridFeatureState = createFeatureSelector<AppointmentStatusGridState>('appointmentStatusGrid');


export const getSubscribeToAppointmentStatusGridData = createSelector(
    getappointmentStatusGridFeatureState,
    state => state.subscribeToAppointmentStatusGridData
);

export const getAppointmentStatusGridData = createSelector(
    getappointmentStatusGridFeatureState,
    state => state.gridData
);

export const getAppointmentStatusLocationIdFilter = createSelector(
    getappointmentStatusGridFeatureState,
    state => state.locationId
);

export const getAppointmentStatusTenantIdFilter = createSelector(
  getappointmentStatusGridFeatureState,
  state => state.tenantId
);

export const getAppointmentStatusSearchFilter = createSelector(
  getappointmentStatusGridFeatureState,
  state => state.searchText
);

export const getAppointmentStatusPageInfo = createSelector(
    getappointmentStatusGridFeatureState,
    state => {
        return {
            page: state.page,
            pageSize: state.pageSize
        };
    }
);

export const getAppointmentStatusSortInfo = createSelector(
    getappointmentStatusGridFeatureState,
    state => {
        return {
            sortColumn: state.sortColumn,
            sortDirection: state.sortDirection
        };
    }
);
export const getAppointmentStatusFromDate = createSelector(
    getappointmentStatusGridFeatureState,
    state => {
    return {
        fromDate: state.fromUtcDateString,
        toDate: state.toUtcDateString
    };
}
);

export const getAppointmentStatusToDate = createSelector(
    getappointmentStatusGridFeatureState,
    state => state.toUtcDateString
);

export const getPreferredLanguageId = createSelector(
  getLoggedInUserInfo,
  (user) => {
    if (user && user.preferredLanguage) {
      return user.preferredLanguage;
    }
    return 1; // default fallback (1 = English Language)
  }
);

export const getAppointmentStatusGridFilters = createSelector(
    getSubscribeToAppointmentStatusGridData,
    getAppointmentStatusPageInfo,
    getAppointmentStatusSortInfo,
    getAppointmentStatusSearchFilter,
    getAppointmentStatusLocationIdFilter,
    getAppointmentStatusTenantIdFilter,
    getAppointmentStatusFromDate,
    getPreferredLanguageId,
    (requirSubscribe, pageInfo, sortInfo, searchFilter, locationIdFilter, tenantIdFilter,date, preferredLanguageId) => {
        if (requirSubscribe) {
            return {
                TenantId: tenantIdFilter,
                LocationId: locationIdFilter,
                Page: pageInfo.page,
                PageSize: pageInfo.pageSize,
                SortColumn: sortInfo.sortColumn,
                SortDirection: sortInfo.sortDirection,
                SearchText: searchFilter,
                StatusId: null,
                PersonRequestedId: null,
                FromUtcDateString:date.fromDate,
                ToUtcDateString: date.toDate,
                PreferredLanguageId: preferredLanguageId,
            };
        } else {
            return null;
        }
    }
);
